/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class SaleGoalApi {
    static getInstance() {
        if (!this.instance) this.instance = new SaleGoalApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取经销商目标列表
    async getDealerGoalList (param,num,size){
        let url = `/api/goal/dealer/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 新增经销商目标
    async addDealerGoal (param,id){
        let url = `/api/goal/dealer/save`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取销售车架目标列表
    async getSalerGoalList (param){
        // let url = `/api/goal/sale/query`
        let url = `/api/goal/sale/list/year`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 新增销售车架目标
    async addSaleGoal (param){
        let url = `/api/goal/sale/save`
        let result = await this.getData(url,param,'POST')
        return result
    }
    

}

export {
    SaleGoalApi
}